module.exports = __webpack_public_path__ + "static/kendall-256f5d8c1dd415c60a45db5813c3af58.png";